export default __webpack_public_path__ + "static/media/no-image-planar.91c09176.png";